// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar_calendar__2WeXJ"};